import { createApiCall, MethodType, URI } from "../Api";
import { ConsultationsPayload } from "models/consultations/consultationList";
import { ConsultationDetailsPayload } from "models/consultations/consultationDetails";
import { DownloadConsultationCSVPayload } from "models/consultations/downloadConsultationCSV";

export const getConsultations = (payload: ConsultationsPayload) => {
  return createApiCall(
    MethodType.GET,
    URI.CONSULTATIONS.CONSULTATION_LIST,
    payload
  );
};

export const getConsultationDetails = (payload: ConsultationDetailsPayload) => {
  return createApiCall(
    MethodType.GET,
    URI.CONSULTATIONS.CONSULTATION_DETAILS(payload.id)
  );
};

export const downloadConsultationCSV = (
  payload: DownloadConsultationCSVPayload
) => {
  return createApiCall(
    MethodType.GET,
    URI.CONSULTATIONS.DOWNLOAD_CONSULTATION_CSV,
    payload
  );
};
